
/**
 * 환불 신청 상태
 */
export type GetApiV1RefundsMyRequests200AllOfThreeDataItemStatus = typeof GetApiV1RefundsMyRequests200AllOfThreeDataItemStatus[keyof typeof GetApiV1RefundsMyRequests200AllOfThreeDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiV1RefundsMyRequests200AllOfThreeDataItemStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
